import { split } from 'ramda';

export const normalizeBy = (list, by) => {
	const o = {};

	list.forEach((element) => {
		const key = element[by];
		o[key] = element;
	});

	return o;
};

export const findById =
	(array = []) =>
	(id) =>
		array.find((element) => element.id === id);

export const updatePropOnId = (data, id, prop, value) => {
	return data.map((item) => {
		if (item.id === id) {
			return {
				...item,
				[prop]: value,
			};
		} else {
			return item;
		}
	});
};

export const splitPath = split('.');
